
<!--{{listaCombustiveis | json  }}-->
<ul class="nav justify-content-center">

  <li class="nav-item" *ngFor=" let combustivel of listaCombustiveis" >
    <a class="nav-link btn btn-secondary btn-combustivel"
       [ngClass]="{'btn-selecionado' : combustivelSelecionado == combustivel.descricaoCombustivel}"
       href="javascript:void(0)" (click)="openGas(combustivel.descricaoCombustivel);">
      <div>
        {{combustivel.combustivel}}
      </div>
    </a>
  </li>

</ul>
